import { useBuild } from "~/components/build/Show/lib/BuildContext";
import TestEngine from "~/components/build/Show/components/TestEngine";
import { Navigate } from "react-router-dom";
import classNames from "classnames";

export default function Tests() {
  const { build } = useBuild();
  const buildSidebarDisabled = !Features.BuildSidebar;
  const testTabUrl = build.testEngine.testTabUrls?.tabUrl;

  if (!testTabUrl) {
    return <Navigate to={build.path} replace={true} />;
  }

  return (
    <div
      className={classNames("relative min-w-0 flex-auto contain-layout", {
        "-mt-3": buildSidebarDisabled,
      })}
    >
      <div className="absolute h-full w-full overflow-y-auto rounded-b-md bg-white">
        <TestEngine build={build} />
      </div>
    </div>
  );
}
